module.exports = __webpack_public_path__ + "static/media/ISFJ.675a1549.png";